import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { IJobOrderDataState } from 'app/models';
import { compare, compareDates } from 'app/utils/compare';

export enum JobOrderDataStateElementSelectioState {
  UNCHANGED = 'UNCHANGED',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
}
export interface JobOrderDataStateElement extends IJobOrderDataState {
  selectionState: JobOrderDataStateElementSelectioState;
  isSelected: boolean;
}

@Component({
  selector: 'app-job-order-data-state-list-component',
  templateUrl: './job-order-data-state-list.component.html',
  styleUrls: ['./job-order-data-state-list.component.scss'],
})
export class JobOrderDataStateListComponent implements OnInit {
  @Output()
  dataStateCheckChanged = new EventEmitter<JobOrderDataStateElement>();

  localJobOrderDataStates: JobOrderDataStateElement[] = [];
  masterAllSelected = false;

  @Input()
  set jobOrderDataStates(value: Map<string, JobOrderDataStateElement>) {
    this.localJobOrderDataStates = [...value.values()];
  }

  columnsToDisplay: string[] = [
    'selection',
    'operation',
    'description',
    'machineName',
    'startDate',
  ];

  constructor() {}

  ngOnInit(): void {}

  sortData = (sort: Sort): void => {
    if (this.localJobOrderDataStates) {
      const data = this.localJobOrderDataStates.slice();
      if (!sort.active || sort.direction === '') {
        this.localJobOrderDataStates = data;
        return;
      }

      this.localJobOrderDataStates = [
        ...data.sort((a: IJobOrderDataState, b: IJobOrderDataState) => {
          const isAsc = sort.direction === 'asc';
          switch (sort.active) {
            case 'operation':
              return compare(a.operation, b.operation, isAsc);
            case 'description':
              return compare(a.description, b.description, isAsc);
            case 'machineName':
              return compare(a.machineName, b.machineName, isAsc);
            case 'startDate':
              return compareDates(
                new Date(a.startDate ?? ''),
                new Date(b.startDate ?? ''),
                isAsc
              );
            default:
              return 0;
          }
        }),
      ];
    }
  };

  onDataStateCheckChanged(onDataStateCheckChanged: JobOrderDataStateElement) {
    this.dataStateCheckChanged.emit(onDataStateCheckChanged);
  }

  isAllRowsSelected() {
    return this.localJobOrderDataStates.every((value) => value.isSelected);
   }

   isAllRowsNotSelected() {
    return this.localJobOrderDataStates.every((value) => !value.isSelected);
   }

  selectAllRows() {
    if(!this.isAllRowsSelected()){
    this.localJobOrderDataStates.forEach((value) => {
      if(!value.isSelected){
        this.dataStateCheckChanged.emit(value);
      }
    });
  }
  this.masterAllSelected = true;
  }


  unselectAllRows() {
    if(!this.isAllRowsNotSelected()){
      this.localJobOrderDataStates.forEach((value) => {
        if(value.isSelected){
          this.dataStateCheckChanged.emit(value);
        }
      });
    }
    this.masterAllSelected = false;
  }

  masterRowsToggle() {
    return this.masterAllSelected ? this.unselectAllRows() : this.selectAllRows();
  }
}
